import { overviewStats } from "@/mocks/site";

const accents = [
  "text-primary-700 bg-primary-100",
  "text-accent-800 bg-accent-100",
  "text-primary-800 bg-primary-100",
  "text-secondary-900 bg-secondary-100",
];

export default function ProgressBand() {
  return (
    <section className="w-full bg-background-50 px-4 py-12 md:px-6 md:py-16 lg:px-10">
      <div className="mb-7 flex flex-col gap-2 md:flex-row md:items-end md:justify-between">
        <div>
          <p className="text-xs font-medium tracking-[0.25em] text-primary-700">
            VERIFY PROGRESS
          </p>
          <h2 className="mt-2 font-heading text-xl font-bold tracking-tight text-foreground-950 md:text-2xl">
            本轮求证进度概览
          </h2>
        </div>
        <p className="max-w-xl text-sm leading-relaxed text-foreground-600">
          我们把线索拆成三种状态：已核实、待证实、存在矛盾。数字会随新材料补充而变动，不作永久结论。
        </p>
      </div>

      <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4">
        {overviewStats.map((stat, index) => (
          <div
            key={stat.label}
            className="rounded-lg border border-background-200 bg-background-100 p-4 transition-colors hover:border-primary-300 md:p-5"
          >
            <span
              className={`inline-flex h-8 w-8 items-center justify-center rounded-md ${accents[index % accents.length]}`}
            >
              <i
                className={`text-lg ${
                  index === 1
                    ? "ri-checkbox-circle-line"
                    : index === 2
                      ? "ri-error-warning-line"
                      : index === 3
                        ? "ri-search-line"
                        : "ri-file-list-3-line"
                }`}
              ></i>
            </span>
            <p className="mt-4 flex items-baseline gap-1">
              <span className="font-heading text-3xl font-black text-foreground-950">
                {stat.value}
              </span>
              <span className="text-sm text-foreground-500">{stat.unit}</span>
            </p>
            <p className="mt-1 font-heading text-sm font-semibold text-foreground-900">
              {stat.label}
            </p>
            <p className="mt-1.5 text-xs leading-relaxed text-foreground-500">
              {stat.hint}
            </p>
          </div>
        ))}
      </div>
    </section>
  );
}